import api from '@/utils/api';

/**
 * Update user
 * @param {object} accountProfileData - The account profile data
 * @returns {Promise}
 */
const updateAccountProfileApi = (accountProfileData) =>
  api.patch(`/user/my-account`, accountProfileData);

export default updateAccountProfileApi;
